<template>
  <div
    v-if="visible"
    data-testid="cookie-consent-banner"
    class="fixed bottom-0 inset-x-0 z-50 bg-gray-900 text-white px-4 py-3 sm:flex sm:items-center sm:justify-center sm:gap-4"
  >
    <p class="text-sm text-center sm:text-left">
      We use cookies to measure how well our ads work. Nothing is tracked unless
      you accept.
    </p>
    <div class="mt-2 sm:mt-0 flex gap-2 justify-center flex-shrink-0">
      <button
        data-testid="consent-accept"
        class="btn-primary text-sm px-4 py-1"
        @click="choose(true)"
      >
        Accept
      </button>
      <button
        data-testid="consent-decline"
        class="text-sm px-4 py-1 border border-gray-500 rounded-md hover:bg-gray-800"
        @click="choose(false)"
      >
        Decline
      </button>
    </div>
  </div>
</template>

<script>
import { computed, inject, ref } from "vue";
import { routeLocationKey } from "vue-router";
import {
  isAnalyticsConfigured,
  getStoredConsent,
  updateConsent,
  isTagFreePath,
} from "@/services/analytics.service";

export default {
  name: "CookieConsentBanner",
  setup() {
    const eligible = ref(
      !window.__CYPRESS_TEST_MODE__ &&
        isAnalyticsConfigured() &&
        getStoredConsent() === null
    );

    // Injected with a null default so the component still mounts without a
    // router (unit tests). Falls back to the landing path in that case.
    const route = inject(routeLocationKey, null);
    const currentPath = computed(() =>
      route ? route.path : window.location.pathname
    );

    const visible = computed(
      () => eligible.value && !isTagFreePath(currentPath.value)
    );

    const choose = (granted) => {
      updateConsent(granted);
      eligible.value = false;
    };

    return { visible, choose };
  },
};
</script>
